import { render, staticRenderFns } from "./ActRecord.vue?vue&type=template&id=52a75b5a&scoped=true"
import script from "./ActRecord.vue?vue&type=script&lang=js"
export * from "./ActRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a75b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52a75b5a')) {
      api.createRecord('52a75b5a', component.options)
    } else {
      api.reload('52a75b5a', component.options)
    }
    module.hot.accept("./ActRecord.vue?vue&type=template&id=52a75b5a&scoped=true", function () {
      api.rerender('52a75b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/sign-challenge/components/ActRecord.vue"
export default component.exports